module.exports = __webpack_public_path__ + "img/codPostal.a0ade113.png";